















































import { Component, Vue } from "vue-property-decorator";
import { appColors } from "../../common/AppConst";
import { Getter } from "vuex-class";
import {
  RootActionNames,
  RootGetterNames,
  RootMutationNames,
} from "@/vuex-store";
import { RouterTools } from "@/common/RouterTools";
import router from "@/router";

/** 菜单 item */
type NavMenuItem = {
  path?: string;
  title: string;
  actived?: boolean;
  icon: string;
  onClick?: () => void;
};

@Component
export default class LeftNav extends Vue {
  readonly leftNavBgColor: string = appColors.primaryColor;

  get mainMenuItems(): NavMenuItem[] {
    return [
      {
        path: RouterTools.pagePaths.writing,
        title: "工作台",
        icon: "el-icon-monitor",
      },
      {
        path: RouterTools.pagePaths.example,
        title: "错别字检测",
        icon: "el-icon-document-checked",
      },
      {
        path: RouterTools.pagePaths.aiCopywriter,
        title: "智能创作",
        icon: "el-icon-edit-outline",
      },
      {
        path: RouterTools.pagePaths.video2Audio,
        title: "视频提取音频",
        icon: "el-icon-microphone",
      },
      {
        path: RouterTools.pagePaths.speechRecognition,
        title: "音/视频提取文案",
        icon: "el-icon-document-add",
      },
    ];
  }

  get footerMenuItems(): NavMenuItem[] {
    return [
      {
        path: RouterTools.pagePaths.pay,
        title: "次数购买",
        actived: true,
        icon: "el-icon-shopping-cart-2",
      },
      {
        path: RouterTools.pagePaths.customer,
        title: "客服",
        icon: "el-icon-phone-outline",
      },
      {
        title: this.isLogined ? "退出" : "登录",
        icon: "el-icon-s-custom",
        onClick: this.isLogined ? this.clickSignOutItem : this.clickLoginItem,
      },
    ];
  }

  @Getter(RootGetterNames.isLogined)
  readonly isLogined!: boolean;

  get activedPath() {
    return this.$route.path || "/writing";
  }

  //  点击登录菜单
  clickLoginItem() {
    this.$store.commit(RootMutationNames.setShowLoginPanel, true);
  }

  // 点击导航菜单
  clickNavItem(item: NavMenuItem) {
    if (item.onClick) item.onClick();
    else if (item.path) this.$router.push(item.path);
  }

  // 退出
  async clickSignOutItem() {
    await this.$confirm("是否退出登录?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    await this.$store.dispatch(RootActionNames.logout);
  }
}
